import { render, staticRenderFns } from "./superwordFloor.vue?vue&type=template&id=68b79063&scoped=true"
import script from "./superwordFloor.vue?vue&type=script&lang=js"
export * from "./superwordFloor.vue?vue&type=script&lang=js"
import style0 from "./superwordFloor.vue?vue&type=style&index=0&id=68b79063&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68b79063",
  null
  
)

export default component.exports